export default "__VITE_ASSET__DXWPEzXG__"